import { all } from 'redux-saga/effects';

import wimTransitsWatchSaga from './wim/transits/saga';

function* wimsWatchSaga() {
  yield all([wimTransitsWatchSaga()]);
}

export default wimsWatchSaga;
